module.exports = __webpack_public_path__ + "assets/logo_cloud.fe3f3017.svg";